<template>
  <div class="layout empty">
      <slot/>
  </div>
</template>

<script>
  export default {

  }
</script>

<style scoped lang="scss">
  @import './../styles/variables';
</style>
